// 日志工具，根据配置控制是否输出日志
import { APP_CONFIG } from '../config/generated';

// 检查是否启用日志（从 APP_CONFIG 读取，如果 log 为 0 则不输出）
const isLogEnabled = () => {
  // 如果配置中有 LOG 字段，且值为 0，则不输出日志
  const logConfig = (APP_CONFIG as any).LOG;
  return logConfig !== '0' && logConfig !== 0;
};

// 日志工具类
export const logger = {
  log: (...args: any[]) => {
    if (isLogEnabled()) {
      console.log(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isLogEnabled()) {
      console.debug(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isLogEnabled()) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isLogEnabled()) {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isLogEnabled()) {
      console.info(...args);
    }
  }
};

